import React from 'react';
import { useState } from 'react';
import { useResponsive } from 'hooks/useResponsive';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Skeleton
} from '@mui/material';
const CodigosLer = props => {
  const [isExpandido, setExpandido] = useState(false);
  const { isMDDown } = useResponsive();

  const residuos = {
    '01': {
      title:
        ' Residuos de la prospección, extracción de minas y canteras y tratamientos físicos y químicos de minerales',
      subsections: {
        '01 03': {
          title:
            'Residuos de la transformación física y química de minerales metálicos.',
          items: [
            {
              code: '01 03 04*',
              text: 'Estériles que generan ácido procedentes de la transformación de sulfuros.'
            },
            {
              code: '01 03 05*',
              text: 'Otros estériles que contienen sustancias peligrosas.'
            },
            {
              code: '01 03 06',
              text: 'Estériles distintos de los mencionados en los códigos 01 03 04 y 01 03 05.'
            },
            {
              code: '01 03 07*',
              text: 'Otros residuos que contienen sustancias peligrosas procedentes de la transformación física y química de minerales metálicos.'
            },
            {
              code: '01 03 08',
              text: 'Residuos de polvo y arenilla distintos de los mencionados en el código 01 03 07.'
            },
            {
              code: '01 03 09',
              text: 'Lodos rojos de la producción de alúmina distintos de los mencionados en el código 01 03 07.'
            },
            {
              code: '01 03 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '01 04': {
          title:
            'Residuos de la transformación física y química de minerales no metálicos.',
          items: [
            {
              code: '01 04 07*',
              text: 'Residuos que contienen sustancias peligrosas procedentes de la transformación física y química de minerales no metálicos.'
            },
            {
              code: '01 04 08',
              text: 'Residuos de grava y rocas trituradas distintos de los mencionados en el código 01 04 07.'
            },
            { code: '01 04 09', text: 'Residuos de arena y arcillas.' },
            {
              code: '01 04 10',
              text: 'Residuos de polvo y arenilla distintos de los mencionados en el código 01 04 07.'
            },
            {
              code: '01 04 11',
              text: 'Residuos de la transformación de potasa y sal gema distintos de los mencionados en el código 01 04 07.'
            },
            {
              code: '01 04 12',
              text: 'Estériles y otros residuos del lavado y limpieza de minerales distintos de los mencionados en los códigos 01 04 07 y 01 04 11.'
            },
            {
              code: '01 04 13',
              text: 'Residuos del corte y serrado de piedra distintos de los mencionados en el código 01 04 07.'
            },
            {
              code: '01 04 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },

    '02': {
      title:
        'Residuos de la agricultura, horticultura, acuicultura, silvicultura, caza y pesca; residuos de la preparación y elaboración de alimentos',
      subsections: {
        '02 01': {
          title:
            'Residuos de la agricultura, horticultura, acuicultura, silvicultura, caza y pesca.',
          items: [
            { code: '02 01 01', text: 'Lodos de lavado y limpieza.' },
            { code: '02 01 02', text: 'Residuos de tejidos de animales.' },
            { code: '02 01 03', text: 'Residuos de tejidos de vegetales.' }
          ]
        }
      }
    },

    '03': {
      title:
        'Residuos de la transformación de la madera y de la producción de tableros y muebles, pasta de papel, papel y cartón',
      subsections: {
        '03 01': {
          title:
            'Residuos de la transformación de la madera y de la producción de tableros y muebles.',
          items: [
            { code: '03 01 01', text: 'Residuos de corteza y corcho.' },
            {
              code: '03 01 04*',
              text: 'Serrín, virutas, recortes, madera, tableros de partículas y chapas que contienen sustancias peligrosas.'
            },
            {
              code: '03 01 05',
              text: 'Serrín, virutas, recortes, madera, tableros de partículas y chapas distintos de los mencionados en el código 03 01 04.'
            },
            {
              code: '03 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '03 02': {
          title: 'Residuos de los tratamientos de conservación de la madera.',
          items: [
            {
              code: '03 02 01*',
              text: 'Conservantes de la madera orgánicos no halogenados.'
            },
            {
              code: '03 02 02*',
              text: 'Conservantes de la madera organoclorados.'
            },
            {
              code: '03 02 03*',
              text: 'Conservantes de la madera organometálicos.'
            },
            {
              code: '03 02 04*',
              text: 'Conservantes de la madera inorgánicos.'
            },
            {
              code: '03 02 05*',
              text: 'Otros conservantes de la madera que contienen sustancias peligrosas.'
            },
            {
              code: '03 02 99',
              text: 'Conservantes de la madera no especificados en otra categoría.'
            }
          ]
        },
        '03 03': {
          title:
            'Residuos de la producción y transformación de pasta de papel, papel y cartón.',
          items: [
            { code: '03 03 01', text: 'Residuos de corteza y madera.' },
            {
              code: '03 03 02',
              text: 'Lodos de lejías verdes [procedentes de la recuperación de lejías de cocción].'
            },
            {
              code: '03 03 05',
              text: 'Lodos de destintado procedentes del reciclado de papel.'
            },
            {
              code: '03 03 07',
              text: 'Desechos, separados mecánicamente, de pasta elaborada a partir de residuos de papel y cartón.'
            },
            {
              code: '03 03 08',
              text: 'Residuos procedentes de la clasificación de papel y cartón destinados al reciclado.'
            },
            { code: '03 03 09', text: 'Residuos de lodos calizos.' },
            {
              code: '03 03 10',
              text: 'Desechos de fibras y lodos de fibras, de materiales de carga y de estucado, obtenidos por separación mecánica.'
            },
            {
              code: '03 03 11',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 03 03 10.'
            },
            {
              code: '03 03 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },

    '04': {
      title: 'Residuos de las industrias del cuero, de la piel y textil',
      subsections: {
        '04 01': {
          title: 'Residuos de las industrias del cuero y de la piel.',
          items: [
            { code: '04 01 01', text: 'Carnazas y serrajes de encalado.' },
            { code: '04 01 02', text: 'Residuos de encalado.' },
            {
              code: '04 01 03*',
              text: 'Residuos de desengrasado que contienen disolventes sin fase líquida.'
            },
            {
              code: '04 01 04',
              text: 'Residuos líquidos de curtición que contienen cromo.'
            },
            {
              code: '04 01 05',
              text: 'Residuos líquidos de curtición que no contienen cromo.'
            },
            {
              code: '04 01 06',
              text: 'Lodos, en particular los procedentes del tratamiento in situ de efluentes, que contienen cromo.'
            },
            {
              code: '04 01 07',
              text: 'Lodos, en particular los procedentes del tratamiento in situ de efluentes, que no contienen cromo.'
            },
            {
              code: '04 01 08',
              text: 'Residuos de piel curtida [serrajes, rebajaduras, recortes, polvo de esmerilado] que contienen cromo.'
            },
            { code: '04 01 09', text: 'Residuos de confección y acabado.' },
            {
              code: '04 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '04 02': {
          title: 'Residuos de la industria textil.',
          items: [
            {
              code: '04 02 09',
              text: 'Residuos de materiales compuestos [tejidos impregnados, elastómeros, plastómeros].'
            },
            {
              code: '04 02 10',
              text: 'Materia orgánica de productos naturales [por ejemplo grasa, cera].'
            },
            {
              code: '04 02 14*',
              text: 'Residuos del acabado que contienen disolventes orgánicos.'
            },
            {
              code: '04 02 15',
              text: 'Residuos del acabado distintos de los especificados en el código 04 02 14.'
            },
            {
              code: '04 02 16*',
              text: 'Colorantes y pigmentos que contienen sustancias peligrosas.'
            },
            {
              code: '04 02 17',
              text: 'Colorantes y pigmentos distintos de los mencionados en el código 04 02 16.'
            },
            {
              code: '04 02 19*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '04 02 20',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los mencionados en el código 04 02 19.'
            },
            {
              code: '04 02 21',
              text: 'Residuos de fibras textiles no procesadas.'
            },
            {
              code: '04 02 22',
              text: 'Residuos de fibras textiles procesadas.'
            },
            {
              code: '04 02 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },

    '05': {
      title:
        'Residuos del refino del petróleo, de la purificación del gas natural y del tratamiento pirolítico del carbón',
      subsections: {
        '05 01': {
          title: 'Residuos del refino del petróleo.',
          items: [
            { code: '05 01 02*', text: 'Lodos de desalación.' },
            { code: '05 01 03*', text: 'Lodos de fondos de tanques.' },
            { code: '05 01 04*', text: 'Lodos de alquil ácido.' },
            { code: '05 01 05*', text: 'Derrames de hidrocarburos.' },
            {
              code: '05 01 06*',
              text: 'Lodos oleosos procedentes de operaciones de mantenimiento de plantas o equipos.'
            },
            { code: '05 01 07*', text: 'Alquitranes ácidos.' },
            { code: '05 01 08*', text: 'Otros alquitranes.' },
            {
              code: '05 01 09*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '05 01 10',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los mencionados en el código 05 01 09.'
            },
            {
              code: '05 01 11*',
              text: 'Residuos procedentes de la limpieza de combustibles con bases.'
            },
            { code: '05 01 12*', text: 'Hidrocarburos que contienen ácidos.' },
            {
              code: '05 01 13',
              text: 'Lodos procedentes del agua de alimentación de calderas.'
            },
            {
              code: '05 01 14',
              text: 'Residuos de columnas de refrigeración.'
            },
            { code: '05 01 15*', text: 'Arcillas de filtración usadas.' },
            {
              code: '05 01 16',
              text: 'Residuos que contienen azufre procedentes de la desulfuración del petróleo.'
            },
            { code: '05 01 17', text: 'Betunes.' },
            {
              code: '05 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '05 06': {
          title: 'Residuos del tratamiento pirolítico del carbón.',
          items: [
            { code: '05 06 01*', text: 'Alquitranes ácidos.' },
            { code: '05 06 03*', text: 'Otros alquitranes.' },
            {
              code: '05 06 04',
              text: 'Residuos de columnas de refrigeración.'
            },
            {
              code: '05 06 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '05 07': {
          title: 'Residuos de la purificación y transporte del gas natural.',
          items: [
            { code: '05 07 01*', text: 'Residuos que contienen mercurio.' },
            { code: '05 07 02', text: 'Residuos que contienen azufre.' },
            {
              code: '05 07 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },

    '06': {
      title: 'Residuos de procesos químicos inorgánicos',
      subsections: {
        '06 01': {
          title:
            'Residuos de la fabricación, formulación, distribución y utilización [FFDU] de ácidos.',
          items: [
            { code: '06 01 01*', text: 'Ácido sulfúrico y ácido sulfuroso.' },
            { code: '06 01 02*', text: 'Ácido clorhídrico.' },
            { code: '06 01 03*', text: 'Ácido fluorhídrico.' },
            { code: '06 01 04*', text: 'Ácido fosfórico y ácido fosforoso.' },
            { code: '06 01 05*', text: 'Ácido nítrico y ácido nitroso.' },
            { code: '06 01 06*', text: 'Otros ácidos.' },
            {
              code: '06 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 02': {
          title: 'Residuos de la FFDU de bases.',
          items: [
            { code: '06 02 01*', text: 'Hidróxido cálcico.' },
            { code: '06 02 03*', text: 'Hidróxido amónico.' },
            {
              code: '06 02 04*',
              text: 'Hidróxido potásico e hidróxido sódico.'
            },
            { code: '06 02 05*', text: 'Otras bases.' },
            {
              code: '06 02 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 03': {
          title:
            'Residuos de la FFDU de sales y sus soluciones y de óxidos metálicos.',
          items: [
            {
              code: '06 03 11*',
              text: 'Sales sólidas y soluciones que contienen cianuros.'
            },
            {
              code: '06 03 13*',
              text: 'Sales sólidas y soluciones que contienen metales pesados.'
            },
            {
              code: '06 03 14',
              text: 'Sales sólidas y soluciones distintas de las mencionadas en los códigos 06 03 11 y 06 03 13.'
            },
            {
              code: '06 03 15*',
              text: 'Óxidos metálicos que contienen metales pesados.'
            },
            {
              code: '06 03 16',
              text: 'Óxidos metálicos distintos de los mencionados en el código 06 03 15.'
            },
            {
              code: '06 03 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 04': {
          title:
            'Residuos que contienen metales distintos de los mencionados en el subcapítulo 06 03.',
          items: [
            { code: '06 04 03*', text: 'Residuos que contienen arsénico.' },
            { code: '06 04 04*', text: 'Residuos que contienen mercurio.' },
            {
              code: '06 04 05*',
              text: 'Residuos que contienen otros metales pesados.'
            },
            {
              code: '06 04 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 05': {
          title: 'Lodos del tratamiento in situ de efluentes.',
          items: [
            {
              code: '06 05 02*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '06 05 03',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los mencionados en el código 06 05 02.'
            }
          ]
        },
        '06 06': {
          title:
            'Residuos de la FFDU de productos químicos que contienen azufre, de procesos químicos del azufre y de procesos de desulfuración.',
          items: [
            {
              code: '06 06 02*',
              text: 'Residuos que contienen sulfuros peligrosos.'
            },
            {
              code: '06 06 03',
              text: 'Residuos que contienen sulfuros distintos de los mencionados en el código 06 06 02.'
            },
            {
              code: '06 06 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 07': {
          title:
            'Residuos de la FFDU de halógenos y de procesos químicos de los halógenos.',
          items: [
            {
              code: '06 07 01*',
              text: 'Residuos de electrólisis que contienen amianto.'
            },
            {
              code: '06 07 02*',
              text: 'Carbón activo procedente de la producción de cloro.'
            },
            {
              code: '06 07 03*',
              text: 'Lodos de sulfato bárico que contienen mercurio.'
            },
            {
              code: '06 07 04*',
              text: 'Soluciones y ácidos, por ejemplo, ácido de contacto.'
            },
            {
              code: '06 07 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 08': {
          title: 'Residuos de la FFDU del silicio y sus derivados.',
          items: [
            {
              code: '06 08 02*',
              text: 'Residuos que contienen clorosilanos peligrosos.'
            },
            {
              code: '06 08 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 09': {
          title:
            'Residuos de la FFDU de productos químicos que contienen fósforo y de procesos químicos del fósforo.',
          items: [
            { code: '06 09 02', text: 'Escorias de fósforo.' },
            {
              code: '06 09 03*',
              text: 'Residuos cálcicos de reacción que contienen o están contaminados con sustancias peligrosas.'
            },
            {
              code: '06 09 04',
              text: 'Residuos cálcicos de reacción distintos de los mencionados en el código 06 09 03.'
            },
            {
              code: '06 09 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 10': {
          title:
            'Residuos de la FFDU de productos químicos que contienen nitrógeno, de procesos químicos del nitrógeno y de la fabricación de fertilizantes.',
          items: [
            {
              code: '06 10 02*',
              text: 'Residuos que contienen sustancias peligrosas.'
            },
            {
              code: '06 10 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 11': {
          title:
            'Residuos de la fabricación de pigmentos inorgánicos y o pacificantes.',
          items: [
            {
              code: '06 11 01',
              text: 'Residuos cálcicos de reacción procedentes de la producción de dióxido de titanio.'
            },
            {
              code: '06 11 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '06 13': {
          title:
            'Residuos de procesos químicos inorgánicos no especificados en otra categoría.',
          items: [
            {
              code: '06 13 01*',
              text: 'Productos fitosanitarios inorgánicos, conservantes de la madera y otros biocidas.'
            },
            {
              code: '06 13 02*',
              text: 'Carbón activo usado [excepto el código 06 07 02].'
            },
            { code: '06 13 03', text: 'Negro de carbono.' },
            {
              code: '06 13 04*',
              text: 'Residuos procedentes de la transformación del amianto.'
            },
            { code: '06 13 05*', text: 'Hollín.' },
            {
              code: '06 13 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },

    '07': {
      title: 'Residuos de procesos químicos orgánicos',
      subsections: {
        '07 01': {
          title:
            'Residuos de la fabricación, formulación, distribución y utilización [FFDU] de productos químicos orgánicos de base.',
          items: [
            {
              code: '07 01 01*',
              text: 'Líquidos de limpieza y licores madre acuosos.'
            },
            {
              code: '07 01 03*',
              text: 'Disolventes, líquidos de limpieza y licores madre organo halogenados.'
            },
            {
              code: '07 01 04*',
              text: 'Otros disolventes, líquidos de limpieza y licores madre orgánicos.'
            },
            {
              code: '07 01 07*',
              text: 'Residuos de reacción y de destilación halogenados.'
            },
            {
              code: '07 01 08*',
              text: 'Otros residuos de reacción y de destilación.'
            },
            {
              code: '07 01 09*',
              text: 'Tortas de filtración y absorbentes usados halogenados.'
            },
            {
              code: '07 01 10*',
              text: 'Otras tortas de filtración y absorbentes usados.'
            },
            {
              code: '07 01 11*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '07 01 12',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 07 01 11.'
            },
            {
              code: '07 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '07 02': {
          title:
            'Residuos de la FFDU de plásticos, caucho sintético y fibras artificiales.',
          items: [
            {
              code: '07 02 01*',
              text: 'Líquidos de limpieza y licores madre acuosos.'
            },
            {
              code: '07 02 03*',
              text: 'Disolventes, líquidos de limpieza y licores madre organohalogenados.'
            },
            {
              code: '07 02 04*',
              text: 'Otros disolventes, líquidos de limpieza y licores madre orgánicos.'
            },
            {
              code: '07 02 07*',
              text: 'Residuos de reacción y de destilación halogenados.'
            },
            {
              code: '07 02 08*',
              text: 'Otros residuos de reacción y de destilación.'
            },
            {
              code: '07 02 09*',
              text: 'Tortas de filtración y absorbentes usados halogenados.'
            },
            {
              code: '07 02 10*',
              text: 'Otras tortas de filtración y absorbentes usados.'
            },
            {
              code: '07 02 11*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '07 02 12',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 07 02 11.'
            },
            { code: '07 02 13', text: 'Residuos de plástico.' },
            {
              code: '07 02 14*',
              text: 'Residuos procedentes de aditivos que contienen sustancias peligrosas.'
            },
            {
              code: '07 02 15',
              text: 'Residuos procedentes de aditivos, distintos de los especificados en el código 07 02 14.'
            },
            {
              code: '07 02 16*',
              text: 'Residuos que contienen siliconas peligrosas.'
            },
            {
              code: '07 02 17',
              text: 'Residuos que contienen siliconas distintas de las mencionadas en el código 07 02 16.'
            },
            {
              code: '07 02 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '07 03': {
          title:
            'Residuos de la FFDU de tintes y pigmentos orgánicos [excepto los del subcapítulo 06 11].',
          items: [
            {
              code: '07 03 01*',
              text: 'Líquidos de limpieza y licores madre acuosos.'
            },
            {
              code: '07 03 03*',
              text: 'Disolventes, líquidos de limpieza y licores madre organohalogenados.'
            },
            {
              code: '07 03 04*',
              text: 'Otros disolventes, líquidos de limpieza y licores madre orgánicos.'
            },
            {
              code: '07 03 07*',
              text: 'Residuos de reacción y de destilación halogenados.'
            },
            {
              code: '07 03 08*',
              text: 'Otros residuos de reacción y de destilación.'
            },
            {
              code: '07 03 09*',
              text: 'Tortas de filtración y absorbentes usados halogenados.'
            },
            {
              code: '07 03 10*',
              text: 'Otras tortas de filtración y absorbentes usados.'
            },
            {
              code: '07 03 11*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '07 03 12',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 07 03 11.'
            },
            {
              code: '07 03 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '07 04': {
          title:
            'Residuos de la FFDU de productos fitosanitarios orgánicos [excepto los de los códigos 02 01 9 y 02 01 09], de conservantes de la madera [excepto los del subcapítulo 03 02] y de otros biocidas.',
          items: [
            {
              code: '07 04 01*',
              text: 'Líquidos de limpieza y licores madre acuosos.'
            },
            {
              code: '07 04 03*',
              text: 'Disolventes, líquidos de limpieza y licores madre organohalogenados.'
            },
            {
              code: '07 04 04*',
              text: 'Otros disolventes, líquidos de limpieza y licores madre orgánicos.'
            },
            {
              code: '07 04 07*',
              text: 'Residuos de reacción y de destilación halogenados.'
            },
            {
              code: '07 04 08*',
              text: 'Otros residuos de reacción y de destilación.'
            },
            {
              code: '07 04 09*',
              text: 'Tortas de filtración y absorbentes usados halogenados.'
            },
            {
              code: '07 04 10*',
              text: 'Otras tortas de filtración y absorbentes usados.'
            },
            {
              code: '07 04 11*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '07 04 12',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 07 04 11.'
            },
            {
              code: '07 04 13*',
              text: 'Residuos sólidos que contienen sustancias peligrosas.'
            },
            {
              code: '07 04 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '07 05': {
          title: 'Residuos de la FFDU de productos farmacéuticos.',
          items: [
            {
              code: '07 05 01*',
              text: 'Líquidos de limpieza y licores madre acuosos.'
            },
            {
              code: '07 05 03*',
              text: 'Disolventes, líquidos de limpieza y licores madre organohalogenados.'
            },
            {
              code: '07 05 04*',
              text: 'Otros disolventes, líquidos de limpieza y licores madre orgánicos.'
            },
            {
              code: '07 05 07*',
              text: 'Residuos de reacción y de destilación halogenados.'
            },
            {
              code: '07 05 08*',
              text: 'Otros residuos de reacción y de destilación.'
            },
            {
              code: '07 05 09*',
              text: 'Tortas de filtración y absorbentes usados halogenados.'
            },
            {
              code: '07 05 10*',
              text: 'Otras tortas de filtración y absorbentes usados.'
            },
            {
              code: '07 05 11*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '07 05 12',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 07 05 11.'
            },
            {
              code: '07 05 13*',
              text: 'Residuos sólidos que contienen sustancias peligrosas.'
            },
            {
              code: '07 05 14',
              text: 'Residuos sólidos distintos de los especificados en el código 07 05 13.'
            },
            {
              code: '07 05 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '07 06': {
          title:
            'Residuos de la FFDU de grasas, jabones, detergentes, desinfectantes y cosméticos.',
          items: [
            {
              code: '07 06 01*',
              text: 'Líquidos de limpieza y licores madre acuosos.'
            },
            {
              code: '07 06 03*',
              text: 'Disolventes, líquidos de limpieza y licores madre organohalogenados.'
            },
            {
              code: '07 06 04*',
              text: 'Otros disolventes, líquidos de limpieza y licores madre orgánicos.'
            },
            {
              code: '07 06 07*',
              text: 'Residuos de reacción y de destilación halogenados.'
            },
            {
              code: '07 06 08*',
              text: 'Otros residuos de reacción y de destilación.'
            },
            {
              code: '07 06 09*',
              text: 'Tortas de filtración y absorbentes usados halogenados.'
            },
            {
              code: '07 06 10*',
              text: 'Otras tortas de filtración y absorbentes usados.'
            },
            {
              code: '07 06 11*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '07 06 12',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 07 06 11.'
            },
            {
              code: '07 06 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '07 07': {
          title:
            'Residuos de la FFDU de productos químicos resultantes de la química fina y productos químicos no especificados en otra categoría.',
          items: [
            {
              code: '07 07 01*',
              text: 'Líquidos de limpieza y licores madre acuosos.'
            },
            {
              code: '07 07 03*',
              text: 'Disolventes, líquidos de limpieza y licores madre organohalogenados.'
            },
            {
              code: '07 07 04*',
              text: 'Otros disolventes, líquidos de limpieza y licores madre orgánicos.'
            },
            {
              code: '07 07 07*',
              text: 'Residuos de reacción y de destilación halogenados.'
            },
            {
              code: '07 07 08*',
              text: 'Otros residuos de reacción y de destilación.'
            },
            {
              code: '07 07 09*',
              text: 'Tortas de filtración y absorbentes usados halogenados.'
            },
            {
              code: '07 07 10*',
              text: 'Otras tortas de filtración y absorbentes usados.'
            },
            {
              code: '07 07 11*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '07 07 12',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 07 07 11.'
            },
            {
              code: '07 07 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },

    '08': {
      title:
        'Residuos de la fabricación, formulación, distribución y utilización [FFDU] de revestimientos [pinturas, barnices y esmaltes vítreos], adhesivos, sellantes y tintas de impresión',
      subsections: {
        '08 01': {
          title:
            'Residuos de la FFDU y del decapado o eliminación de pintura y barniz.',
          items: [
            {
              code: '08 01 11*',
              text: 'Residuos de pintura y barniz que contienen disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 01 12',
              text: 'Residuos de pintura y barniz distintos de los especificados en el código 08 01 11.'
            },
            {
              code: '08 01 13*',
              text: 'Lodos de pintura y barniz que contienen disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 01 14',
              text: 'Lodos de pintura y barniz distintos de los especificados en el código 08 0113.'
            },
            {
              code: '08 01 15*',
              text: 'Lodos acuosos que contienen pintura o barniz con disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 01 16',
              text: 'Lodos acuosos que contienen pintura o barniz distintos de los especificados en el código 08 02 15.'
            },
            {
              code: '08 01 17*',
              text: 'Residuos del decapado o eliminación de pintura y barniz que contienen disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 01 18',
              text: 'Residuos del decapado o eliminación de pintura y barniz distintos de los especificados en el código 08 01 17.'
            },
            {
              code: '08 01 19*',
              text: 'Suspensiones acuosas que contienen pintura o barniz con disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 01 20',
              text: 'Suspensiones acuosas que contienen pintura o barniz distintos de los especificados en el código 08 01 19.'
            },
            {
              code: '08 01 21*',
              text: 'Residuos de decapantes o desbarnizadores.'
            },
            {
              code: '08 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '08 02': {
          title:
            'Residuos de la FFDU de otros revestimientos [incluidos materiales cerámicos].',
          items: [
            {
              code: '08 02 01',
              text: 'Residuos de arenillas de revestimiento.'
            },
            {
              code: '08 02 02',
              text: 'Lodos acuosos que contienen materiales cerámicos.'
            },
            {
              code: '08 02 03',
              text: 'Suspensiones acuosas que contienen materiales cerámicos.'
            },
            {
              code: '08 02 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '08 03': {
          title: 'Residuos de la FFDU de tintas de impresión.',
          items: [
            { code: '08 03 07', text: 'Lodos acuosos que contienen tinta.' },
            {
              code: '08 03 08',
              text: 'Residuos líquidos acuosos que contienen tinta.'
            },
            {
              code: '08 03 12*',
              text: 'Residuos de tintas que contienen sustancias peligrosas.'
            },
            {
              code: '08 03 13',
              text: 'Residuos de tintas distintos de los especificados en el código 08 03 12.'
            },
            {
              code: '08 03 14*',
              text: 'Lodos de tinta que contienen sustancias peligrosas.'
            },
            {
              code: '08 03 15',
              text: 'Lodos de tinta distintos de los especificados en el código 08 03 14.'
            },
            { code: '08 03 16*', text: 'Residuos de soluciones corrosivas.' },
            {
              code: '08 03 17*',
              text: 'Residuos de tóner de impresión que contienen sustancias peligrosas.'
            },
            {
              code: '08 03 18',
              text: 'Residuos de tóner de impresión distintos de los especificados en el código 08 03 17.'
            },
            { code: '08 03 19*', text: 'Aceites de dispersión.' },
            {
              code: '08 03 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '08 04': {
          title:
            'Residuos de la FFDU de adhesivos y sellantes [incluyendo productos de impermeabilización].',
          items: [
            {
              code: '08 04 09*',
              text: 'Residuos de adhesivos y sellantes que contienen disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 04 10',
              text: 'Residuos de adhesivos y sellantes distintos de los especificados en el código 08 04 09.'
            },
            {
              code: '08 04 11*',
              text: 'Lodos de adhesivos y sellantes que contienen disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 04 12',
              text: 'Lodos de adhesivos y sellantes distintos de los especificados en el código 08 04 11.'
            },
            {
              code: '08 04 13*',
              text: 'Lodos acuosos que contienen adhesivos o sellantes con disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 04 14',
              text: 'Lodos acuosos que contienen adhesivos o sellantes distintos de los especificados en el código 08 04 13.'
            },
            {
              code: '08 04 15*',
              text: 'Residuos líquidos acuosos que contienen adhesivos o sellantes con disolventes orgánicos u otras sustancias peligrosas.'
            },
            {
              code: '08 04 16',
              text: 'Residuos líquidos acuosos que contienen adhesivos o sellantes, distintos de los especificados en el código 08 04 15.'
            },
            { code: '08 04 17*', text: 'Aceite de resina.' },
            {
              code: '08 04 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '08 05': {
          title: 'Residuos no especificados en otra parte del capítulo 08.',
          items: [{ code: '08 05 01*', text: 'Isocianatos residuales.' }]
        }
      }
    },

    '09': {
      title: 'Residuos de la industria fotográfica',
      subsections: {
        '09 01': {
          title: 'Residuos de la industria fotográfica.',
          items: [
            {
              code: '09 01 01*',
              text: 'Soluciones de revelado y soluciones activadoras al agua.'
            },
            {
              code: '09 01 02*',
              text: 'Soluciones de revelado de placas de impresión al agua.'
            },
            {
              code: '09 01 03*',
              text: 'Soluciones de revelado con disolventes.'
            },
            { code: '09 01 04*', text: 'Soluciones de fijado.' },
            {
              code: '09 01 05*',
              text: 'Soluciones de blanqueo y soluciones de blanqueo-fijado.'
            },
            {
              code: '09 01 06*',
              text: 'Residuos que contienen plata procedentes del tratamiento in situ de residuos fotográficos.'
            },
            {
              code: '09 01 07',
              text: 'Películas y papel fotográfico que contienen plata o compuestos de plata.'
            },
            {
              code: '09 01 08',
              text: 'Películas y papel fotográfico que no contienen plata ni compuestos de plata.'
            },
            {
              code: '09 01 10',
              text: 'Cámaras de un solo uso sin pilas ni acumuladores.'
            },
            {
              code: '09 01 11*',
              text: 'Cámaras de un solo uso con pilas o acumuladores incluidos en los códigos 16 06 01, 16 7 02 ó 16 06 03.'
            },
            {
              code: '09 01 12',
              text: 'Cámaras de un solo uso con pilas o acumuladores distintas de las especificadas en el código 09 01 11.'
            },
            {
              code: '09 01 13*',
              text: 'Residuos líquidos acuosos, procedentes de la recuperación in situ de plata, distintos de los especificados en el código 09 01 06.'
            },
            {
              code: '09 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },

    10: {
      title: 'Residuos de procesos térmicos',
      subsections: {
        '10 01': {
          title:
            'Residuos de centrales eléctricas y otras plantas de combustión [excepto los del capítulo 19].',
          items: [
            {
              code: '10 01 01',
              text: 'Cenizas de hogar, escorias y polvo de caldera [excepto el polvo de caldera especificado en el código 10 01 04].'
            },
            { code: '10 01 02', text: 'Cenizas volantes de carbón.' },
            {
              code: '10 01 03',
              text: 'Cenizas volantes de turba y de madera [no tratada].'
            },
            {
              code: '10 01 04*',
              text: 'Cenizas volantes y polvo de caldera de hidrocarburos.'
            },
            {
              code: '10 01 05',
              text: 'Residuos cálcicos de reacción, en forma sólida, procedentes de la desulfuración de gases de combustión.'
            },
            {
              code: '10 01 07',
              text: 'Residuos cálcicos de reacción, en forma de lodos, procedentes de la desulfuración de gases de combustión.'
            },
            { code: '10 01 09*', text: 'Ácido sulfúrico.' },
            {
              code: '10 01 13*',
              text: 'Cenizas volantes de hidrocarburos emulsionados usados como combustibles.'
            },
            {
              code: '10 01 14*',
              text: 'Cenizas de hogar, escorias y polvo de caldera, procedentes de la coincineración, que contienen sustancias peligrosas.'
            },
            {
              code: '10 01 15',
              text: 'Cenizas de hogar, escorias y polvo de caldera, procedentes de la coincineración, distintos de los especificados en el código 10 01 14.'
            },
            {
              code: '10 01 16*',
              text: 'Cenizas volantes procedentes de la coincineración que contienen sustancias peligrosas.'
            },
            {
              code: '10 01 17',
              text: 'Cenizas volantes procedentes de la coincineración distintas de las especificadas en el código 10 01 16.'
            },
            {
              code: '10 01 18*',
              text: 'Residuos, procedentes de la depuración de gases, que contienen sustancias peligrosas.'
            },
            {
              code: '10 01 19',
              text: 'Residuos, procedentes de la depuración de gases, distintos de los especificados en los códigos 10 01 05, 10 01 07 y 10 01 18.'
            },
            {
              code: '10 01 20*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '10 01 21',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 10 01 20.'
            },
            {
              code: '10 01 22*',
              text: 'Lodos acuosos, procedentes de la limpieza de calderas, que contienen sustancias peligrosas.'
            },
            {
              code: '10 01 23',
              text: 'Lodos acuosos, procedentes de la limpieza de calderas, distintos de los especificados en el código 10 01 22.'
            },
            { code: '10 01 24', text: 'Arenas de lechos fluidizados.' },
            {
              code: '10 01 25',
              text: 'Residuos procedentes del almacenamiento y preparación de combustible de centrales eléctricas de carbón.'
            },
            {
              code: '10 01 26',
              text: 'Residuos del tratamiento del agua de refrigeración.'
            },
            {
              code: '10 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '10 02': {
          title: 'Residuos de la industria del hierro y del acero.',
          items: [
            { code: '10 02 01', text: 'Residuos del tratamiento de escorias.' },
            { code: '10 02 02', text: 'Escorias no tratadas.' },
            {
              code: '10 02 07*',
              text: 'Residuos sólidos, del tratamiento de gases, que contienen sustancias peligrosas.'
            },
            {
              code: '10 02 08',
              text: 'Residuos sólidos del tratamiento de gases distintos de los especificados en el código 10 02 07.'
            },
            { code: '10 02 10', text: 'Cascarilla de laminación.' },
            {
              code: '10 02 11*',
              text: 'Residuos del tratamiento del agua de refrigeración que contienen aceites.'
            },
            {
              code: '10 02 12',
              text: 'Residuos del tratamiento del agua de refrigeración distintos de los especificados en el código 10 02 11.'
            },
            {
              code: '10 02 13*',
              text: 'Lodos y tortas de filtración, del tratamiento de gases, que contienen sustancias peligrosas.'
            },
            {
              code: '10 02 14',
              text: 'Lodos y tortas de filtración, del tratamiento de gases, distintos de los especificados en el código 10 02 13.'
            },
            { code: '10 02 15', text: 'Otros lodos y tortas de filtración.' },
            {
              code: '10 02 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '10 03': {
          title: 'Residuos de la termometalurgia del aluminio.',
          items: [
            { code: '10 03 02', text: 'Fragmentos de ánodos.' },
            { code: '10 03 04*', text: 'Escorias de la producción primaria.' },
            { code: '10 03 05', text: 'Residuos de alúmina.' },
            {
              code: '10 03 08*',
              text: 'Escorias salinas de la producción secundaria.'
            },
            {
              code: '10 03 09*',
              text: 'Granzas negras de la producción secundaria.'
            },
            {
              code: '10 03 15*',
              text: 'Espumas inflamables o que emiten, en contacto con el agua, gases inflamables en cantidades peligrosas.'
            },
            {
              code: '10 03 16',
              text: 'Espumas distintas de las especificadas en el código 10 03 15.'
            },
            {
              code: '10 03 17*',
              text: 'Residuos que contienen alquitrán procedentes de la fabricación de ánodos.'
            },
            {
              code: '10 03 18',
              text: 'Residuos que contienen carbono procedentes de la fabricación de ánodos distintos de los especificados en el código 10 03 17.'
            },
            {
              code: '10 03 19*',
              text: 'Partículas, procedentes de los efluentes gaseosos, que contienen sustancias peligrosas.'
            },
            {
              code: '10 03 20',
              text: 'Partículas procedentes de los efluentes gaseosos, distintas de las especificadas en el código 10 03 19.'
            },
            {
              code: '10 03 21*',
              text: 'Otras partículas y polvo [incluido el polvo de molienda] que contienen sustancias peligrosas.'
            },
            {
              code: '10 03 22',
              text: 'Otras partículas y polvo [incluido el polvo de molienda] distintos de los especificados en el código 10 03 21.'
            },
            {
              code: '10 03 23*',
              text: 'Residuos sólidos, del tratamiento de gases, que contienen sustancias peligrosas.'
            },
            {
              code: '10 03 24',
              text: 'Residuos sólidos, del tratamiento de gases, distintos de los especificados en el código 10 03 23.'
            },
            {
              code: '10 03 25*',
              text: 'Lodos y tortas de filtración, del tratamiento de gases, que contienen sustancias peligrosas.'
            },
            {
              code: '10 03 26',
              text: 'Lodos y tortas de filtración del tratamiento de gases, distintos de los especificados en el código 10 03 25.'
            },
            {
              code: '10 03 27*',
              text: 'Residuos del tratamiento del agua de refrigeración que contienen aceites.'
            },
            {
              code: '10 03 28',
              text: 'Residuos del tratamiento del agua de refrigeración, distintos de los especificados en el código 10 03 27.'
            },
            {
              code: '10 03 29*',
              text: 'Residuos del tratamiento de escorias salinas y granzas negras, que contienen sustancias peligrosas.'
            },
            {
              code: '10 03 30',
              text: 'Residuos del tratamiento de escorias salinas y granzas negras, distintos de los especificados en el código 10 03 29.'
            },
            {
              code: '10 03 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },

        '10 04': {
          title: 'Residuos de la termometalurgia del plomo.',
          items: [
            {
              code: '10 04 01*',
              text: 'Escorias de la producción primaria y secundaria.'
            },
            {
              code: '10 04 02*',
              text: 'Granzas y espumas de la producción primaria y secundaria.'
            },
            { code: '10 04 03*', text: 'Arseniato de calcio.' },
            {
              code: '10 04 04*',
              text: 'Partículas procedentes de los efluentes gaseosos.'
            },
            { code: '10 04 05*', text: 'Otras partículas y polvos.' },
            {
              code: '10 04 06*',
              text: 'Residuos sólidos del tratamiento de gases.'
            },
            {
              code: '10 04 07*',
              text: 'Lodos y tortas de filtración del tratamiento de gases.'
            },
            {
              code: '10 04 09*',
              text: 'Residuos del tratamiento del agua de refrigeración que contienen aceites.'
            },
            {
              code: '10 04 10',
              text: 'Residuos del tratamiento del agua de refrigeración distintos de los especificados en el código 10 04 09.'
            },
            {
              code: '10 04 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },

        '10 05': {
          title: 'Residuos de la termometalurgia del zinc.',
          items: [
            {
              code: '10 05 01',
              text: 'Escorias de la producción primaria y secundaria.'
            },
            {
              code: '10 05 03*',
              text: 'Partículas procedentes de los efluentes gaseosos.'
            },
            { code: '10 05 04', text: 'Otras partículas y polvos.' },
            {
              code: '10 05 05*',
              text: 'Residuos sólidos del tratamiento de gases.'
            },
            {
              code: '10 05 06*',
              text: 'Lodos y tortas de filtración del tratamiento de gases.'
            },
            {
              code: '10 05 08*',
              text: 'Residuos del tratamiento del agua de refrigeración que contienen aceites.'
            },
            {
              code: '10 05 09',
              text: 'Residuos del tratamiento del agua de refrigeración distintos de los especificados en el código 10 05 08.'
            },
            {
              code: '10 05 10*',
              text: 'Granzas y espumas inflamables o que emiten, en contacto con el agua, gases inflamables en cantidades peligrosas.'
            },
            {
              code: '10 05 11',
              text: 'Granzas y espumas distintas de las especificadas en el código 10 05 10.'
            },
            {
              code: '10 05 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },

        '10 06': {
          title: 'Residuos de la termometalurgia del cobre.',
          items: [
            {
              code: '10 06 01',
              text: 'Escorias de la producción primaria y secundaria.'
            },
            {
              code: '10 06 02',
              text: 'Granzas y espumas de la producción primaria y secundaria.'
            },
            {
              code: '10 06 03*',
              text: 'Partículas procedentes de los efluentes gaseosos.'
            },
            { code: '10 06 04', text: 'Otras partículas y polvos.' },
            {
              code: '10 06 06*',
              text: 'Residuos sólidos del tratamiento de gases.'
            },
            {
              code: '10 06 07*',
              text: 'Lodos y tortas de filtración del tratamiento de gases.'
            },
            {
              code: '10 06 09*',
              text: 'Residuos del tratamiento del agua de refrigeración que contienen aceites.'
            },
            {
              code: '10 06 10',
              text: 'Residuos del tratamiento del agua de refrigeración distintos de los especificados en el código 10 06 09.'
            },
            {
              code: '10 06 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },

        '10 07': {
          title: 'Residuos de la termometalurgia de la plata, oro y platino.',
          items: [
            {
              code: '10 07 01',
              text: 'Escorias de la producción primaria y secundaria.'
            },
            {
              code: '10 07 02',
              text: 'Granzas y espumas de la producción primaria y secundaria.'
            },
            {
              code: '10 07 03',
              text: 'Residuos sólidos del tratamiento de gases.'
            },
            { code: '10 07 04', text: 'Otras partículas y polvos.' },
            {
              code: '10 07 05',
              text: 'Lodos y tortas de filtración del tratamiento de gases.'
            },
            {
              code: '10 07 07*',
              text: 'Residuos del tratamiento del agua de refrigeración que contienen aceites.'
            },
            {
              code: '10 07 08',
              text: 'Residuos del tratamiento del agua de refrigeración distintos de los especificados en el código 10 07 07.'
            },
            {
              code: '10 07 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },

        '10 08': {
          title: 'Residuos de la termometalurgia de otros metales no férreos.',
          items: [
            { code: '10 08 04', text: 'Partículas y polvo.' },
            {
              code: '10 08 08*',
              text: 'Escorias salinas de la producción primaria y secundaria.'
            },
            { code: '10 08 09', text: 'Otras escorias.' },
            {
              code: '10 08 10*',
              text: 'Granzas y espumas inflamables o que emiten, en contacto con el agua, gases inflamables en cantidades peligrosas.'
            },
            {
              code: '10 08 11',
              text: 'Granzas y espumas distintas de las especificadas en el código 10 08 10.'
            },
            {
              code: '10 08 12*',
              text: 'Residuos que contienen alquitrán procedentes de la fabricación de ánodos.'
            },
            {
              code: '10 08 13',
              text: 'Residuos que contienen carbono procedentes de la fabricación de ánodos distintos de los especificados en el código 10 08 12.'
            },
            { code: '10 08 14', text: 'Fragmentos de ánodos.' },
            {
              code: '10 08 15*',
              text: 'Partículas, procedentes de los efluentes gaseosos, que contienen sustancias peligrosas.'
            },
            {
              code: '10 08 16',
              text: 'Partículas procedentes de los efluentes gaseosos distintas de las especificadas en el código 10 08 15.'
            },
            {
              code: '10 08 17*',
              text: 'Lodos y tortas de filtración del tratamiento de gases, que contienen sustancias peligrosas.'
            },
            {
              code: '10 08 18',
              text: 'Lodos y tortas de filtración del tratamiento de gases, distintos de los especificados en el código 10 08 17.'
            },
            {
              code: '10 08 19*',
              text: 'Residuos del tratamiento del agua de refrigeración que contienen aceites.'
            },
            {
              code: '10 08 20',
              text: 'Residuos del tratamiento del agua de refrigeración distintos de los especificados en el código 10 08 19.'
            },
            {
              code: '10 08 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },
    11: {
      title:
        'Residuos del tratamiento químico de superficie y del recubrimiento de metales y otros materiales; residuos de la hidrometalurgia no férrica',
      subsections: {
        '11 01': {
          title:
            'Residuos del tratamiento químico de superficie y del recubrimiento de metales y otros materiales [por ejemplo, procesos de galvanización, procesos de recubrimiento con zinc, procesos de decapado, grabado, fosfatación, desengrasado alcalino y anodización].',
          items: [
            { code: '11 01 05*', text: 'Ácidos de decapado.' },
            {
              code: '11 01 06*',
              text: 'Ácidos no especificados en otra categoría.'
            },
            { code: '11 01 07*', text: 'Bases de decapado.' },
            { code: '11 01 08*', text: 'Lodos de fosfatación.' },
            {
              code: '11 01 09*',
              text: 'Lodos y tortas de filtración que contienen sustancias peligrosas.'
            },
            {
              code: '11 01 10',
              text: 'Lodos y tortas de filtración distintos de los especificados en el código 11 01 09.'
            },
            {
              code: '11 01 11*',
              text: 'Líquidos acuosos de enjuague que contienen sustancias peligrosas.'
            },
            {
              code: '11 01 12',
              text: 'Líquidos acuosos de enjuague distintos de los especificados en el código 11 01 11.'
            },
            {
              code: '11 01 13*',
              text: 'Residuos de desengrasado que contienen sustancias peligrosas.'
            },
            {
              code: '11 01 14',
              text: 'Residuos de desengrasado distintos de los especificados en el código 11 01 13.'
            },
            {
              code: '11 01 15*',
              text: 'Eluatos y lodos, procedentes de sistemas de membranas o de intercambio iónico, que contienen sustancias peligrosas.'
            },
            {
              code: '11 01 16*',
              text: 'Resinas intercambiadoras de iones saturadas o usadas.'
            },
            {
              code: '11 01 98*',
              text: 'Otros residuos que contienen sustancias peligrosas.'
            },
            {
              code: '11 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '11 02': {
          title: 'Residuos de procesos hidrometalúrgicos no férreos.',
          items: [
            {
              code: '11 02 02*',
              text: 'Lodos de la hidrometalurgia del zinc [incluidas jarosita y goethita].'
            },
            {
              code: '11 02 03',
              text: 'Residuos de la producción de ánodos para procesos de electrólisis acuosa.'
            },
            {
              code: '11 02 05*',
              text: 'Residuos de procesos de la hidrometalurgia del cobre que contienen sustancias peligrosas.'
            },
            {
              code: '11 02 06',
              text: 'Residuos de procesos de la hidrometalurgia del cobre distintos de los especificados en el código 11 02 05.'
            },
            {
              code: '11 02 07*',
              text: 'Otros residuos que contienen sustancias peligrosas.'
            },
            {
              code: '11 02 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '11 03': {
          title: 'Lodos y sólidos de procesos de temple.',
          items: [
            { code: '11 03 01*', text: 'Residuos que contienen cianuro.' },
            { code: '11 03 02*', text: 'Otros residuos.' }
          ]
        },
        '11 05': {
          title: 'Residuos de procesos de galvanización en caliente.',
          items: [
            { code: '11 05 01', text: 'Matas de galvanización.' },
            { code: '11 05 02', text: 'Cenizas de zinc.' },
            {
              code: '11 05 03*',
              text: 'Residuos sólidos del tratamiento de gases.'
            },
            { code: '11 05 04*', text: 'Fundentes usados.' },
            {
              code: '11 05 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },

    12: {
      title:
        'Residuos del moldeado y del tratamiento físico y mecánico de superficie de metales y plásticos',
      subsections: {
        '12 01': {
          title:
            'Residuos del moldeado y tratamiento físico y mecánico de superficie de metales y plásticos.',
          items: [
            {
              code: '12 01 01',
              text: 'Limaduras y virutas de metales férreos.'
            },
            {
              code: '12 01 02',
              text: 'Polvo y partículas de metales férreos.'
            },
            {
              code: '12 01 03',
              text: 'Limaduras y virutas de metales no férreos.'
            },
            {
              code: '12 01 04',
              text: 'Polvo y partículas de metales no férreos.'
            },
            { code: '12 01 05', text: 'Virutas y rebabas de plástico.' },
            {
              code: '12 01 06*',
              text: 'Aceites minerales de mecanizado que contienen halógenos [excepto las emulsiones o disoluciones].'
            },
            {
              code: '12 01 07*',
              text: 'Aceites minerales de mecanizado sin halógenos [excepto las emulsiones o disoluciones].'
            },
            {
              code: '12 01 08*',
              text: 'Emulsiones y disoluciones de mecanizado que contienen halógenos.'
            },
            {
              code: '12 01 09*',
              text: 'Emulsiones y disoluciones de mecanizado sin halógenos.'
            },
            { code: '12 01 10*', text: 'Aceites sintéticos de mecanizado.' },
            { code: '12 01 12*', text: 'Ceras y grasas usadas.' },
            { code: '12 01 13', text: 'Residuos de soldadura.' },
            {
              code: '12 01 14*',
              text: 'Lodos de mecanizado que contienen sustancias peligrosas.'
            },
            {
              code: '12 01 15',
              text: 'Lodos de mecanizado distintos de los especificados en el código 12 01 14.'
            },
            {
              code: '12 01 16*',
              text: 'Residuos de granallado o chorreado que contienen sustancias peligrosas.'
            },
            {
              code: '12 01 17',
              text: 'Residuos de granallado o chorreado distintos de los especificados en el código 12 01 16.'
            },
            {
              code: '12 01 18*',
              text: 'Lodos metálicos [lodos de esmerilado, rectificado y lapeado] que contienen aceites.'
            },
            {
              code: '12 01 19*',
              text: 'Aceites de mecanizado fácilmente biodegradables.'
            },
            {
              code: '12 01 20*',
              text: 'Muelas y materiales de esmerilado usados que contienen sustancias peligrosas.'
            },
            {
              code: '12 01 21',
              text: 'Muelas y materiales de esmerilado usados distintos de los especificados en el código 12 01 20.'
            },
            {
              code: '12 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '12 03': {
          title:
            'Residuos de los procesos de desengrase con agua y vapor [excepto los del capítulo 11].',
          items: [
            { code: '12 03 01*', text: 'Líquidos acuosos de limpieza.' },
            { code: '12 03 02*', text: 'Residuos de desengrase al vapor.' }
          ]
        }
      }
    },

    13: {
      title:
        'Residuos de aceites y de combustibles líquidos [excepto los aceites comestibles y los de los capítulos 05, 12 y 19]',
      subsections: {
        '13 01': {
          title: 'Residuos de aceites hidráulicos.',
          items: [
            {
              code: '13 01 01*',
              text: 'Aceites hidráulicos que contienen PCB.'
            },
            { code: '13 01 04*', text: 'Emulsiones cloradas.' },
            { code: '13 01 05*', text: 'Emulsiones no cloradas.' },
            {
              code: '13 01 09*',
              text: 'Aceites hidráulicos minerales clorados.'
            },
            {
              code: '13 01 10*',
              text: 'Aceites hidráulicos minerales no clorados.'
            },
            { code: '13 01 11*', text: 'Aceites hidráulicos sintéticos.' },
            {
              code: '13 01 12*',
              text: 'Aceites hidráulicos fácilmente biodegradables.'
            },
            { code: '13 01 13*', text: 'Otros aceites hidráulicos.' }
          ]
        },
        '13 02': {
          title:
            'Residuos de aceites de motor, de transmisión mecánica y lubricantes.',
          items: [
            {
              code: '13 02 04*',
              text: 'Aceites minerales clorados de motor, de transmisión mecánica y lubricantes.'
            },
            {
              code: '13 02 05*',
              text: 'Aceites minerales no clorados de motor, de transmisión mecánica y lubricantes.'
            },
            {
              code: '13 02 06*',
              text: 'Aceites sintéticos de motor, de transmisión mecánica y lubricantes.'
            },
            {
              code: '13 02 07*',
              text: 'Aceites fácilmente biodegradables de motor, de transmisión mecánica y lubricantes.'
            },
            {
              code: '13 02 08*',
              text: 'Otros aceites de motor, de transmisión mecánica y lubricantes.'
            }
          ]
        },
        '13 03': {
          title: 'Residuos de aceites de aislamiento y transmisión de calor.',
          items: [
            {
              code: '13 03 01*',
              text: 'Aceites de aislamiento y transmisión de calor que contienen PCB.'
            },
            {
              code: '13 03 06*',
              text: 'Aceites minerales clorados de aislamiento y transmisión de calor distintos de los especificados en el código 13 03 01.'
            },
            {
              code: '13 03 07*',
              text: 'Aceites minerales no clorados de aislamiento y transmisión de calor.'
            },
            {
              code: '13 03 08*',
              text: 'Aceites sintéticos de aislamiento y transmisión de calor.'
            },
            {
              code: '13 03 09*',
              text: 'Aceites fácilmente biodegradables de aislamiento y transmisión de calor.'
            },
            {
              code: '13 03 10*',
              text: 'Otros aceites de aislamiento y transmisión de calor.'
            }
          ]
        },
        '13 04': {
          title: 'Aceites de sentinas.',
          items: [
            {
              code: '13 04 01*',
              text: 'Aceites de sentinas procedentes de la navegación en aguas continentales.'
            },
            {
              code: '13 04 02*',
              text: 'Aceites de sentinas recogidos en muelles.'
            },
            {
              code: '13 04 03*',
              text: 'Aceites de sentinas procedentes de otros tipos de navegación.'
            }
          ]
        },
        '13 05': {
          title: 'Restos de separadores de agua/sustancias aceitosas.',
          items: [
            {
              code: '13 05 01*',
              text: 'Sólidos procedentes de desarenadores y de separadores de agua/sustancias aceitosas.'
            },
            {
              code: '13 05 02*',
              text: 'Lodos de separadores de agua/sustancias aceitosas.'
            },
            { code: '13 05 03*', text: 'Lodos de interceptores.' },
            {
              code: '13 05 06*',
              text: 'Aceites procedentes de separadores de agua/sustancias aceitosas.'
            },
            {
              code: '13 05 07*',
              text: 'Agua aceitosa procedente de separadores de agua/sustancias aceitosas.'
            },
            {
              code: '13 05 08*',
              text: 'Mezcla de residuos procedentes de desarenadores y de separadores de agua/sustancias aceitosas.'
            }
          ]
        },
        '13 07': {
          title: 'Residuos de combustibles líquidos',
          items: [
            { code: '13 07 01*', text: 'Fuel oil y gasóleo.' },
            { code: '13 07 02*', text: 'Gasolina.' },
            {
              code: '13 07 03*',
              text: 'Otros combustibles [incluidas mezclas].'
            }
          ]
        },
        '13 08': {
          title: 'Residuos de aceites no especificados en otra categoría.',
          items: [
            { code: '13 08 01*', text: 'Lodos o emulsiones de desalación.' },
            { code: '13 08 02*', text: 'Otras emulsiones.' },
            {
              code: '13 08 99*',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        }
      }
    },
    14: {
      title:
        'Residuos de disolventes, refrigerantes y propelentes orgánicos [excepto los de los capítulos 07 y 08]',
      subsections: {
        '14 06': {
          title:
            'Residuos de disolventes, refrigerantes y propelentes de espuma y aerosoles orgánicos.',
          items: [
            { code: '14 06 01*', text: 'Clorofluorocarbonos, HCFC, HFC.' },
            {
              code: '14 06 02*',
              text: 'Otros disolventes y mezclas de disolventes halogenados.'
            },
            {
              code: '14 06 03*',
              text: 'Otros disolventes y mezclas de disolventes.'
            },
            {
              code: '14 06 04*',
              text: 'Lodos o residuos sólidos que contienen disolventes halogenados.'
            },
            {
              code: '14 06 05*',
              text: 'Lodos o residuos sólidos que contienen otros disolventes.'
            }
          ]
        }
      }
    },

    15: {
      title:
        'Residuos de envases; absorbentes, trapos de limpieza, materiales de filtración y ropas de protección no especificados en otra categoría',
      subsections: {
        '15 01': {
          title:
            'Envases [incluidos los residuos de envases de la recogida selectiva municipal].',
          items: [
            { code: '15 01 01', text: 'Envases de papel y cartón.' },
            { code: '15 01 02', text: 'Envases de plástico.' },
            { code: '15 01 03', text: 'Envases de madera.' },
            { code: '15 01 04', text: 'Envases metálicos.' },
            { code: '15 01 05', text: 'Envases compuestos.' },
            { code: '15 01 06', text: 'Envases mezclados.' },
            { code: '15 01 07', text: 'Envases de vidrio.' },
            { code: '15 01 09', text: 'Envases textiles.' },
            {
              code: '15 01 10*',
              text: 'Envases que contienen restos de sustancias peligrosas o están contaminados por ellas.'
            },
            {
              code: '15 01 11*',
              text: 'Envases metálicos, incluidos los recipientes a presión vacíos, que contienen una matriz porosa sólida peligrosa [por ejemplo, amianto].'
            }
          ]
        },
        '15 02': {
          title:
            'Absorbentes, materiales de filtración, trapos de limpieza y ropas protectoras.',
          items: [
            {
              code: '15 02 02*',
              text: 'Absorbentes, materiales de filtración [incluidos los filtros de aceite no especificados en otra categoría], trapos de limpieza y ropas protectoras contaminados por sustancias peligrosas.'
            },
            {
              code: '15 02 03',
              text: 'Absorbentes, materiales de filtración, trapos de limpieza y ropas protectoras distintos de los especificados en el código 15 02 02.'
            }
          ]
        }
      }
    },

    16: {
      title: 'Residuos no especificados en otro capítulo de la lista',
      subsections: {
        '16 01': {
          title:
            'Vehículos de diferentes medios de transporte [incluidas las máquinas no de carretera] al final de su vida útil y residuos del desguace de vehículos al final de su vida útil y del mantenimiento de vehículos [excepto los de los capítulos 13 y 14 y los subcapítulos 16 06 y 16 08].',
          items: [
            { code: '16 01 03', text: 'Neumáticos fuera de uso.' },
            { code: '16 01 04*', text: 'Vehículos al final de su vida útil.' },
            {
              code: '16 01 06',
              text: 'Vehículos al final de su vida útil que no contengan líquidos ni otros componentes peligrosos.'
            },
            { code: '16 01 07*', text: 'Filtros de aceite.' },
            { code: '16 01 08*', text: 'Componentes que contienen mercurio.' },
            { code: '16 01 09*', text: 'Componentes que contienen PCB.' },
            {
              code: '16 01 10*',
              text: 'Componentes explosivos [por ejemplo, air bags].'
            },
            {
              code: '16 01 11*',
              text: 'Zapatas de freno que contienen amianto.'
            },
            {
              code: '16 01 12',
              text: 'Zapatas de freno distintas de las especificadas en el código 16 01 11.'
            },
            { code: '16 01 13*', text: 'Líquidos de frenos.' },
            {
              code: '16 01 14*',
              text: 'Anticongelantes que contienen sustancias peligrosas.'
            },
            {
              code: '16 01 15',
              text: 'Anticongelantes distintos de los especificados en el código 16 01 14.'
            },
            { code: '16 01 16', text: 'Depósitos para gases licuados.' },
            { code: '16 01 17', text: 'Metales férreos.' },
            { code: '16 01 18', text: 'Metales no férreos.' },
            { code: '16 01 19', text: 'Plástico.' },
            { code: '16 01 20', text: 'Vidrio.' },
            {
              code: '16 01 21*',
              text: 'Componentes peligrosos distintos de los especificados en los códigos 16 01 07 a 16 01 11 y 16 01 14.'
            },
            {
              code: '16 01 22',
              text: 'Componentes no especificados en otra categoría.'
            },
            {
              code: '16 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '16 02': {
          title: 'Residuos de equipos eléctricos y electrónicos.',
          items: [
            {
              code: '16 02 09*',
              text: 'Transformadores y condensadores que contienen PCB.'
            },
            {
              code: '16 02 10*',
              text: 'Equipos desechados que contienen PCB, o están contaminados por ellos, distintos de los especificados en el código 16 02 09.'
            },
            {
              code: '16 02 11*',
              text: 'Equipos desechados que contienen clorofluorocarbonos, HCFC, HFC.'
            },
            {
              code: '16 02 12*',
              text: 'Equipos desechados que contienen amianto libre.'
            },
            {
              code: '16 02 13*',
              text: 'Equipos desechados que contienen componentes peligrosos, distintos de los especificados en los códigos 16 02 09 a 16 02 12.'
            },
            {
              code: '16 02 14',
              text: 'Equipos desechados distintos de los especificados en los códigos 16 02 09 a 16 02 13.'
            },
            {
              code: '16 02 15*',
              text: 'Componentes peligrosos retirados de equipos desechados.'
            },
            {
              code: '16 02 16',
              text: 'Componentes retirados de equipos desechados, distintos de los especificados en el código 16 02 15.'
            }
          ]
        },
        '16 03': {
          title:
            'Lotes de productos fuera de especificación y productos no utilizados.',
          items: [
            {
              code: '16 03 03*',
              text: 'Residuos inorgánicos que contienen sustancias peligrosas.'
            },
            {
              code: '16 03 04',
              text: 'Residuos inorgánicos distintos de los especificados en el código 16 03 03.'
            },
            {
              code: '16 03 05*',
              text: 'Residuos orgánicos que contienen sustancias peligrosas.'
            },
            {
              code: '16 03 06',
              text: 'Residuos orgánicos distintos de los especificados en el código 16 03 05.'
            }
          ]
        },
        '16 04': {
          title: 'Residuos de explosivos.',
          items: [
            { code: '16 04 01*', text: 'Residuos de municiones.' },
            { code: '16 04 02*', text: 'Residuos de fuegos artificiales.' },
            { code: '16 04 03*', text: 'Otros residuos explosivos.' }
          ]
        },
        '16 05': {
          title:
            'Gases en recipientes a presión y productos químicos desechados.',
          items: [
            {
              code: '16 05 04*',
              text: 'Gases en recipientes a presión [incluidos los halones] que contienen sustancias peligrosas.'
            },
            {
              code: '16 05 05',
              text: 'Gases en recipientes a presión distintos de los especificados en el código 16 05 04.'
            },
            {
              code: '16 05 06*',
              text: 'Productos químicos de laboratorio que consisten en, o contienen, sustancias peligrosas, incluidas las mezclas de productos químicos de laboratorio.'
            },
            {
              code: '16 05 07*',
              text: 'Productos químicos inorgánicos desechados que consisten en, o contienen, sustancias peligrosas.'
            },
            {
              code: '16 05 08*',
              text: 'Productos químicos orgánicos desechados que consisten en, o contienen, sustancias peligrosas.'
            },
            {
              code: '16 05 09',
              text: 'Productos químicos desechados distintos de los especificados en los códigos 16 05 06, 16 05 07 ó 16 05 08.'
            }
          ]
        },
        '16 06': {
          title: 'Pilas y acumuladores.',
          items: [
            { code: '16 06 01*', text: 'Baterías de plomo.' },
            { code: '16 06 02*', text: 'Acumuladores de Ni-Cd.' },
            { code: '16 06 03*', text: 'Pilas que contienen mercurio.' },
            {
              code: '16 06 04',
              text: 'Pilas alcalinas [excepto las del código 16 06 03].'
            },
            { code: '16 06 05', text: 'Otras pilas y acumuladores.' },
            {
              code: '16 06 06*',
              text: 'Electrolito de pilas y acumuladores recogido selectivamente.'
            }
          ]
        },
        '16 07': {
          title:
            'Residuos de la limpieza de cisternas de transporte y almacenamiento y de la limpieza de cubas [excepto los de los capítulos 05 y 13].',
          items: [
            {
              code: '16 07 08*',
              text: 'Residuos que contienen hidrocarburos.'
            },
            {
              code: '16 07 09*',
              text: 'Residuos que contienen otras sustancias peligrosas.'
            },
            {
              code: '16 07 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '16 08': {
          title: 'Catalizadores usados.',
          items: [
            {
              code: '16 08 01',
              text: 'Catalizadores usados que contienen oro, plata, renio, rodio, paladio, iridio o platino [excepto los del código 16 08 07].'
            },
            {
              code: '16 08 02*',
              text: 'Catalizadores usados que contienen metales de transición peligrosos o compuestos de metales de transición peligrosos.'
            },
            {
              code: '16 08 03',
              text: 'Catalizadores usados que contienen metales de transición o compuestos de metales de transición no especificados en otra categoría.'
            },
            {
              code: '16 08 04',
              text: 'Catalizadores usados procedentes del craqueo catalítico en lecho fluido [excepto los del código 16 08 07].'
            },
            {
              code: '16 08 05*',
              text: 'Catalizadores usados que contienen ácido fosfórico.'
            },
            {
              code: '16 08 06*',
              text: 'Líquidos usados utilizados como catalizadores.'
            },
            {
              code: '16 08 07*',
              text: 'Catalizadores usados contaminados con sustancias peligrosas.'
            }
          ]
        },
        '16 09': {
          title: 'Sustancias oxidantes.',
          items: [
            {
              code: '16 09 01*',
              text: 'Permanganatos, por ejemplo, permanganato potásico.'
            },
            {
              code: '16 09 02*',
              text: 'Cromatos, por ejemplo, cromato potásico, dicromato sódico o potásico.'
            },
            {
              code: '16 09 03*',
              text: 'Peróxidos, por ejemplo, peróxido de hidrógeno.'
            },
            {
              code: '16 09 04*',
              text: 'Sustancias oxidantes no especificadas en otra categoría.'
            }
          ]
        },
        '16 10': {
          title:
            'Residuos líquidos acuosos destinados a plantas de tratamiento externas.',
          items: [
            {
              code: '16 10 01*',
              text: 'Residuos líquidos acuosos que contienen sustancias peligrosas.'
            },
            {
              code: '16 10 02',
              text: 'Residuos líquidos acuosos distintos de los especificados en el código 16 10 01.'
            },
            {
              code: '16 10 03*',
              text: 'Concentrados acuosos que contienen sustancias peligrosas.'
            },
            {
              code: '16 10 04',
              text: 'Concentrados acuosos distintos de los especificados en el código 16 10 03.'
            }
          ]
        },
        '16 11': {
          title: 'Residuos de revestimientos de hornos y de refractarios.',
          items: [
            {
              code: '16 11 01*',
              text: 'Revestimientos y refractarios a partir de carbono, procedentes de procesos metalúrgicos, que contienen sustancias peligrosas.'
            },
            {
              code: '16 11 02',
              text: 'Revestimientos y refractarios a partir de carbono, procedentes de procesos metalúrgicos, distintos de los especificados en el código 16 11 01.'
            },
            {
              code: '16 11 03*',
              text: 'Otros revestimientos y refractarios, procedentes de procesos metalúrgicos, que contienen sustancias peligrosas.'
            },
            {
              code: '16 11 04',
              text: 'Otros revestimientos y refractarios procedentes de procesos metalúrgicos, distintos de los especificados en el código 16 11 03.'
            },
            {
              code: '16 11 05*',
              text: 'Revestimientos y refractarios, procedentes de procesos no metalúrgicos, que contienen sustancias peligrosas.'
            },
            {
              code: '16 11 06',
              text: 'Revestimientos y refractarios procedentes de procesos no metalúrgicos, distintos de los especificados en el código 16 11 05.'
            }
          ]
        }
      }
    },
    17: {
      title:
        'Residuos de la construcción y demolición [incluida la tierra excavada de zonas contaminadas]',
      subsections: {
        '17 01': {
          title: 'Hormigón, ladrillos, tejas y materiales cerámicos.',
          items: [
            { code: '17 01 01', text: 'Hormigón.' },
            { code: '17 01 02', text: 'Ladrillos.' },
            { code: '17 01 03', text: 'Tejas y materiales cerámicos.' },
            {
              code: '17 01 06*',
              text: 'Mezclas, o fracciones separadas, de hormigón, ladrillos, tejas y materiales cerámicos, que contienen sustancias peligrosas.'
            },
            {
              code: '17 01 07',
              text: 'Mezclas de hormigón, ladrillos, tejas y materiales cerámicos distintas de las especificadas en el código 17 01 06.'
            }
          ]
        },
        '17 02': {
          title: 'Madera, vidrio y plástico.',
          items: [
            { code: '17 02 01', text: 'Madera.' },
            { code: '17 02 02', text: 'Vidrio.' },
            { code: '17 02 03', text: 'Plástico.' },
            {
              code: '17 02 04*',
              text: 'Vidrio, plástico y madera que contienen sustancias peligrosas o están contaminados por ellas.'
            }
          ]
        },
        '17 03': {
          title:
            'Mezclas bituminosas, alquitrán de hulla y otros productos alquitranados.',
          items: [
            {
              code: '17 03 01*',
              text: 'Mezclas bituminosas que contienen alquitrán de hulla.'
            },
            {
              code: '17 03 02',
              text: 'Mezclas bituminosas distintas de las especificadas en el código 17 03 01.'
            },
            {
              code: '17 03 03*',
              text: 'Alquitrán de hulla y productos alquitranados.'
            }
          ]
        },
        '17 04': {
          title: 'Metales [incluidas sus aleaciones].',
          items: [
            { code: '17 04 01', text: 'Cobre, bronce, latón.' },
            { code: '17 04 02', text: 'Aluminio.' },
            { code: '17 04 03', text: 'Plomo.' },
            { code: '17 04 04', text: 'Zinc.' },
            { code: '17 04 05', text: 'Hierro y acero.' },
            { code: '17 04 06', text: 'Estaño.' },
            { code: '17 04 07', text: 'Metales mezclados.' },
            {
              code: '17 04 09*',
              text: 'Residuos metálicos contaminados con sustancias peligrosas.'
            },
            {
              code: '17 04 10*',
              text: 'Cables que contienen hidrocarburos, alquitrán de hulla y otras sustancias peligrosas.'
            },
            {
              code: '17 04 11',
              text: 'Cables distintos de los especificados en el código 17 04 10.'
            }
          ]
        },
        '17 05': {
          title:
            'Tierra (incluida la excavada de zonas contaminadas), piedras y lodos de drenaje.',
          items: [
            {
              code: '17 05 03*',
              text: 'Tierra y piedras que contienen sustancias peligrosas.'
            },
            {
              code: '17 05 04',
              text: 'Tierra y piedras distintas de las especificadas en el código 17 05 03.'
            },
            {
              code: '17 05 05*',
              text: 'Lodos de drenaje que contienen sustancias peligrosas.'
            },
            {
              code: '17 05 06',
              text: 'Lodos de drenaje distintos de los especificados en el código 17 05 05.'
            },
            {
              code: '17 05 07*',
              text: 'Balasto de vías férreas que contienen sustancias peligrosas.'
            },
            {
              code: '17 05 08',
              text: 'Balasto de vías férreas distinto del especificado en el código 17 05 07.'
            }
          ]
        },
        '17 06': {
          title:
            'Materiales de aislamiento y materiales de construcción que contienen amianto.',
          items: [
            {
              code: '17 06 01*',
              text: 'Materiales de aislamiento que contienen amianto.'
            },
            {
              code: '17 06 03*',
              text: 'Otros materiales de aislamiento que consisten en, o contienen, sustancias peligrosas.'
            },
            {
              code: '17 06 04',
              text: 'Materiales de aislamiento distintos de los especificados en los códigos 17 06 01 y 17 06 03.'
            },
            {
              code: '17 06 05*',
              text: 'Materiales de construcción que contienen amianto.'
            }
          ]
        },
        '17 08': {
          title: 'Materiales de construcción a partir de yeso.',
          items: [
            {
              code: '17 08 01*',
              text: 'Materiales de construcción a partir de yeso contaminados con sustancias peligrosas.'
            },
            {
              code: '17 08 02',
              text: 'Materiales de construcción a partir de yeso distintos de los especificados en el código 17 08 01.'
            }
          ]
        },
        '17 09': {
          title: 'Otros residuos de construcción y demolición.',
          items: [
            {
              code: '17 09 01*',
              text: 'Residuos de construcción y demolición que contienen mercurio.'
            },
            {
              code: '17 09 02*',
              text: 'Residuos de construcción y demolición que contienen PCB [por ejemplo, sellantes que contienen PCB, revestimientos de suelo a partir de resinas que contienen PCB, acristalamientos dobles que contienen PCB, condensadores que contienen PCB].'
            },
            {
              code: '17 09 03*',
              text: 'Otros residuos de construcción y demolición [incluidos los residuos mezclados] que contienen sustancias peligrosas.'
            },
            {
              code: '17 09 04',
              text: 'Residuos mezclados de construcción y demolición distintos de los especificados en los códigos 17 09 01, 17 09 02 y 17 09 03.'
            }
          ]
        }
      }
    },

    18: {
      title:
        'Residuos de servicios médicos o veterinarios o de investigación asociada [salvo los residuos de cocina y de restaurante no procedentes directamente de la prestación de cuidados sanitarios]',
      subsections: {
        '18 01': {
          title:
            'Residuos de maternidades, del diagnóstico, tratamiento o prevención de enfermedades humanas.',
          items: [
            {
              code: '18 01 01',
              text: 'Objetos cortantes y punzantes [excepto los del código 18 01 03].'
            },
            {
              code: '18 01 02',
              text: 'Restos anatómicos y órganos, incluidos bolsas y bancos de sangre [excepto los del código 19 01 03].'
            },
            {
              code: '18 01 03*',
              text: 'Residuos cuya recogida y eliminación es objeto de requisitos especiales para prevenir infecciones.'
            },
            {
              code: '18 01 04',
              text: 'Residuos cuya recogida y eliminación no es objeto de requisitos especiales para prevenir infecciones [por ejemplo, vendajes, vaciados de yeso, ropa blanca, ropa desechable, pañales].'
            },
            {
              code: '18 01 06*',
              text: 'Productos químicos que consisten en, o contienen, sustancias peligrosas.'
            },
            {
              code: '18 01 07',
              text: 'Productos químicos distintos de los especificados en el código 18 01 06.'
            },
            {
              code: '18 01 08*',
              text: 'Medicamentos citotóxicos y citostáticos.'
            },
            {
              code: '18 01 09',
              text: 'Medicamentos distintos de los especificados en el código 18 01 08.'
            },
            {
              code: '18 01 10*',
              text: 'Residuos de amalgamas procedentes de cuidados dentales.'
            }
          ]
        },
        '18 02': {
          title:
            'Residuos de la investigación, diagnóstico, tratamiento o prevención de enfermedades de animales.',
          items: [
            {
              code: '18 02 01',
              text: 'Objetos cortantes y punzantes [excepto los del código 18 02 02].'
            },
            {
              code: '18 02 02*',
              text: 'Residuos cuya recogida y eliminación es objeto de requisitos especiales para prevenir infecciones.'
            },
            {
              code: '18 02 03',
              text: 'Residuos cuya recogida y eliminación no es objeto de requisitos especiales para prevenir infecciones.'
            },
            {
              code: '18 02 05*',
              text: 'Productos químicos que consisten en, o contienen, sustancias peligrosas.'
            },
            {
              code: '18 02 06',
              text: 'Productos químicos distintos de los especificados en el código 18 02 05.'
            },
            {
              code: '18 02 07*',
              text: 'Medicamentos citotóxicos y citostáticos.'
            },
            {
              code: '18 02 08',
              text: 'Medicamentos distintos de los especificados en el código 18 02 07.'
            }
          ]
        }
      }
    },
    19: {
      title:
        'Residuos de las instalaciones para el tratamiento de residuos, de las plantas externas de tratamiento de aguas residuales y de la preparación de agua para consumo humano y de agua para uso industrial',
      subsections: {
        '19 01': {
          title: 'Residuos de la incineración o pirólisis de residuos.',
          items: [
            {
              code: '19 01 02',
              text: 'Materiales férreos separados de la ceniza de fondo de horno.'
            },
            {
              code: '19 01 05*',
              text: 'Torta de filtración del tratamiento de gases.'
            },
            {
              code: '19 01 06*',
              text: 'Residuos líquidos acuosos del tratamiento de gases y otros residuos líquidos acuosos.'
            },
            {
              code: '19 01 07*',
              text: 'Residuos sólidos del tratamiento de gases.'
            },
            {
              code: '19 01 10*',
              text: 'Carbón activo usado procedente del tratamiento de gases.'
            },
            {
              code: '19 01 11*',
              text: 'Cenizas de fondo de horno y escorias que contienen sustancias peligrosas.'
            },
            {
              code: '19 01 12',
              text: 'Cenizas de fondo de horno y escorias distintas de las especificadas en el código 19 01 11.'
            },
            {
              code: '19 01 13*',
              text: 'Cenizas volantes que contienen sustancias peligrosas.'
            },
            {
              code: '19 01 14',
              text: 'Cenizas volantes distintas de las especificadas en el código 19 01 13.'
            },
            {
              code: '19 01 15*',
              text: 'Polvo de caldera que contiene sustancias peligrosas.'
            },
            {
              code: '19 01 16',
              text: 'Polvo de caldera distinto del especificado en el código 19 01 15.'
            },
            {
              code: '19 01 17*',
              text: 'Residuos de pirólisis que contienen sustancias peligrosas.'
            },
            {
              code: '19 01 18',
              text: 'Residuos de pirólisis distintos de los especificados en el código 19 01 17.'
            },
            { code: '19 01 19', text: 'Arenas de lechos fluidizados.' },
            {
              code: '19 01 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '19 02': {
          title:
            'Residuos de tratamientos físico-químicos de residuos [incluidas la escromatación, descianuración y neutralización].',
          items: [
            {
              code: '19 02 03',
              text: 'Residuos mezclados previamente, compuestos exclusivamente por residuos no peligrosos.'
            },
            {
              code: '19 02 04*',
              text: 'Residuos mezclados previamente, compuestos por al menos un residuo peligroso.'
            },
            {
              code: '19 02 05*',
              text: 'Lodos de tratamientos físico-químicos que contienen sustancias peligrosas.'
            },
            {
              code: '19 02 06',
              text: 'Lodos de tratamientos físico-químicos distintos de los especificados en el código 19 02 05.'
            },
            {
              code: '19 02 07*',
              text: 'Aceites y concentrados procedentes del proceso de separación.'
            },
            {
              code: '19 02 08*',
              text: 'Residuos combustibles líquidos que contienen sustancias peligrosas.'
            },
            {
              code: '19 02 09*',
              text: 'Residuos combustibles sólidos que contienen sustancias peligrosas.'
            },
            {
              code: '19 02 10',
              text: 'Residuos combustibles distintos de los especificados en los códigos 19 02 08 y 19 02 09.'
            },
            {
              code: '19 02 11*',
              text: 'Otros residuos que contienen sustancias peligrosas.'
            },
            {
              code: '19 02 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '19 03': {
          title: 'Residuos estabilizados/solidificados [7].',
          items: [
            {
              code: '19 03 04*',
              text: 'Residuos peligrosos parcialmente estabilizados [8].'
            },
            {
              code: '19 03 05',
              text: 'Residuos estabilizados distintos de los especificados en el código 19 03 04.'
            },
            { code: '19 03 06*', text: 'Residuos peligrosos solidificados.' },
            {
              code: '19 03 07',
              text: 'Residuos solidificados distintos de los especificados en el código 19 03 06.'
            }
          ]
        },
        '19 04': {
          title: 'Residuos vitrificados y residuos de la vitrificación.',
          items: [
            { code: '19 04 01', text: 'Residuos vitrificados.' },
            {
              code: '19 04 02*',
              text: 'Cenizas volantes y otros residuos del tratamiento de gases.'
            },
            { code: '19 04 03*', text: 'Fase sólida no vitrificada.' },
            {
              code: '19 04 04',
              text: 'Residuos líquidos acuosos del templado de residuos vitrificados.'
            }
          ]
        },
        '19 05': {
          title: 'Residuos del tratamiento aeróbico de residuos sólidos.',
          items: [
            {
              code: '19 05 01',
              text: 'Fracción no compostada de residuos municipales y asimilados.'
            },
            {
              code: '19 05 02',
              text: 'Fracción no compostada de residuos de procedencia animal o vegetal.'
            },
            { code: '19 05 03', text: 'Compost fuera de especificación.' },
            {
              code: '19 05 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '19 06': {
          title: 'Residuos del tratamiento anaeróbico de residuos.',
          items: [
            {
              code: '19 06 03',
              text: 'Licores del tratamiento anaeróbico de residuos municipales.'
            },
            {
              code: '19 06 04',
              text: 'Lodos de digestión del tratamiento anaeróbico de residuos municipales.'
            },
            {
              code: '19 06 05',
              text: 'Licores del tratamiento anaeróbico de residuos animales y vegetales.'
            },
            {
              code: '19 06 06',
              text: 'Lodos de digestión del tratamiento anaeróbico de residuos animales y vegetales.'
            },
            {
              code: '19 06 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '19 07': {
          title: 'Lixiviados de vertedero.',
          items: [
            {
              code: '19 07 02*',
              text: 'Lixiviados de vertedero que contienen sustancias peligrosas.'
            },
            {
              code: '19 07 03',
              text: 'Lixiviados de vertedero distintos de los especificados en el código 19 07 02.'
            },
            {
              code: '19 07 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '19 08': {
          title:
            'Residuos de plantas de tratamiento de aguas residuales no especificados en otra categoría.',
          items: [
            { code: '19 08 01', text: 'Residuos de cribado.' },
            { code: '19 08 02', text: 'Residuos de desarenado.' },
            {
              code: '19 08 05',
              text: 'Lodos del tratamiento de aguas residuales urbanas.'
            },
            {
              code: '19 08 06*',
              text: 'Resinas intercambiadoras de iones saturadas o usadas.'
            },
            {
              code: '19 08 07*',
              text: 'Soluciones y lodos de la regeneración de intercambiadores de iones.'
            },
            {
              code: '19 08 08*',
              text: 'Residuos procedentes de sistemas de membranas que contienen metales pesados.'
            },
            {
              code: '19 08 09',
              text: 'Mezclas de grasas y aceites procedentes de la separación de agua/sustancias aceitosas, que sólo contienen aceites y grasas comestibles.'
            },
            {
              code: '19 08 10*',
              text: 'Mezclas de grasas y aceites procedentes de la separación de agua/sustancias aceitosas distintas de las especificadas en el código 19 08 09.'
            },
            {
              code: '19 08 11*',
              text: 'Lodos procedentes del tratamiento biológico de aguas residuales industriales, que contienen sustancias peligrosas.'
            },
            {
              code: '19 08 12',
              text: 'Lodos procedentes del tratamiento biológico de aguas residuales industriales, distintos de los especificados en el código 19 08 11.'
            },
            {
              code: '19 08 13*',
              text: 'Lodos procedentes de otros tratamientos de aguas residuales industriales, que contienen sustancias peligrosas.'
            },
            {
              code: '19 08 14',
              text: 'Lodos procedentes de otros tratamientos de aguas residuales industriales distintos de los especificados en el código 19 08 13.'
            },
            {
              code: '19 08 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '19 09': {
          title:
            'Residuos de la preparación de agua para consumo humano o agua para uso industrial.',
          items: [
            {
              code: '19 09 01',
              text: 'Residuos sólidos de la filtración primaria y cribado.'
            },
            { code: '19 09 02', text: 'Lodos de la clarificación del agua.' },
            { code: '19 09 03', text: 'Lodos de descarbonatación.' },
            { code: '19 09 04', text: 'Carbón activo usado.' },
            {
              code: '19 09 05',
              text: 'Resinas intercambiadoras de iones saturadas o usadas.'
            },
            {
              code: '19 09 06',
              text: 'Soluciones y lodos de la regeneración de intercambiadores de iones.'
            },
            {
              code: '19 09 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '19 10': {
          title:
            'Residuos procedentes del fragmentado de residuos que contienen metales.',
          items: [
            { code: '19 10 01', text: 'Residuos de hierro y acero.' },
            { code: '19 10 02', text: 'Residuos no férreos.' },
            {
              code: '19 10 03*',
              text: 'Fracciones ligeras de fragmentación [fluff-light] y polvo que contienen sustancias peligrosas.'
            },
            {
              code: '19 10 04',
              text: 'Fracciones ligeras de fragmentación [fluff-light] y polvo distintos de los especificados en el código 19 10 03.'
            },
            {
              code: '19 10 05*',
              text: 'Otras fracciones que contienen sustancias peligrosas.'
            },
            {
              code: '19 10 06',
              text: 'Otras fracciones distintas de las especificadas en el código 19 10 05.'
            }
          ]
        },
        '19 11': {
          title: 'Residuos de la regeneración de aceites.',
          items: [
            { code: '19 11 01*', text: 'Arcillas de filtración usadas.' },
            { code: '19 11 02*', text: 'Alquitranes ácidos.' },
            { code: '19 11 03*', text: 'Residuos de líquidos acuosos.' },
            {
              code: '19 11 04*',
              text: 'Residuos de la limpieza de combustibles con bases.'
            },
            {
              code: '19 11 05*',
              text: 'Lodos del tratamiento in situ de efluentes que contienen sustancias peligrosas.'
            },
            {
              code: '19 11 06',
              text: 'Lodos del tratamiento in situ de efluentes distintos de los especificados en el código 19 11 05.'
            },
            {
              code: '19 11 07*',
              text: 'Residuos de la depuración de efluentes gaseosos.'
            },
            {
              code: '19 11 99',
              text: 'Residuos no especificados en otra categoría.'
            }
          ]
        },
        '19 12': {
          title:
            'Residuos del tratamiento mecánico de residuos [por ejemplo, clasificación, trituración, compactación, peletización] no especificados en otra categoría.',
          items: [
            { code: '19 12 01', text: 'Papel y cartón.' },
            { code: '19 12 02', text: 'Metales férreos.' },
            { code: '19 12 03', text: 'Metales no férreos.' },
            { code: '19 12 04', text: 'Plástico y caucho.' },
            { code: '19 12 05', text: 'Vidrio.' },
            {
              code: '19 12 06*',
              text: 'Madera que contiene sustancias peligrosas.'
            },
            {
              code: '19 12 07',
              text: 'Madera distinta de la especificada en el código 19 12 06.'
            },
            { code: '19 12 08', text: 'Tejidos.' },
            {
              code: '19 12 09',
              text: 'Minerales [por ejemplo, arena, piedras].'
            },
            {
              code: '19 12 10',
              text: 'Residuos combustibles [combustible derivado de residuos].'
            },
            {
              code: '19 12 11*',
              text: 'Otros residuos [incluidas mezclas de materiales], procedentes del tratamiento mecánico de residuos, que contienen sustancias peligrosas.'
            },
            {
              code: '19 12 12',
              text: 'Otros residuos [incluidas mezclas de materiales] procedentes del tratamiento mecánico de residuos distintos de los especificados en el código 19 12 11.'
            }
          ]
        },
        '19 13': {
          title:
            'Residuos de la recuperación de suelos y de aguas subterráneas.',
          items: [
            {
              code: '19 13 01*',
              text: 'Residuos sólidos, de la recuperación de suelos, que contienen sustancias peligrosas.'
            },
            {
              code: '19 13 02',
              text: 'Residuos sólidos, de la recuperación de suelos, distintos de los especificados en el código 20 13 01.'
            },
            {
              code: '19 13 03*',
              text: 'Lodos de la recuperación de suelos, que contienen sustancias peligrosas.'
            },
            {
              code: '19 13 04',
              text: 'Lodos de la recuperación de suelos, distintos de los especificados en el código 19 13 03.'
            },
            {
              code: '19 13 05*',
              text: 'Lodos de la recuperación de aguas subterráneas, que contienen sustancias peligrosas.'
            },
            {
              code: '19 13 06',
              text: 'Lodos de la recuperación de aguas subterráneas, distintos de los especificados en el código 19 13 05.'
            },
            {
              code: '19 13 07*',
              text: 'Residuos de líquidos acuosos y concentrados acuosos, procedentes de la recuperación de aguas subterráneas, que contienen sustancias peligrosas.'
            },
            {
              code: '19 13 08',
              text: 'Residuos de líquidos acuosos y concentrados acuosos, procedentes de la recuperación de aguas subterráneas, distintos de los especificados en el código 19 13 07.'
            }
          ]
        }
      }
    },
    20: {
      title:
        'Residuos municipales [residuos domésticos y residuos asimilables procedentes de los comercios, industrias e instituciones], incluidas las fracciones recogidas selectivamente',
      subsections: {
        '20 01': {
          title:
            'Fracciones recogidas selectivamente [excepto las especificadas en el subcapítulo 15 01].',
          items: [
            { code: '20 01 01', text: 'Papel y cartón.' },
            { code: '20 01 02', text: 'Vidrio.' },
            {
              code: '20 01 08',
              text: 'Residuos biodegradables de cocinas y restaurantes.'
            },
            { code: '20 01 10', text: 'Ropa.' },
            { code: '20 01 11', text: 'Tejidos.' },
            { code: '20 01 13*', text: 'Disolventes.' },
            { code: '20 01 14*', text: 'Ácidos.' },
            { code: '20 01 15*', text: 'Álcalis.' },
            { code: '20 01 17*', text: 'Productos fotoquímicos.' },
            { code: '20 01 19*', text: 'Pesticidas.' },
            {
              code: '20 01 21*',
              text: 'Tubos fluorescentes y otros residuos que contienen mercurio.'
            },
            {
              code: '20 01 23*',
              text: 'Equipos desechados que contienen clorofluorocarbonos.'
            },
            { code: '20 01 25', text: 'Aceites y grasas comestibles.' },
            {
              code: '20 01 26*',
              text: 'Aceites y grasas distintos de los especificados en el código 20 01 25.'
            },
            {
              code: '20 01 27*',
              text: 'Pinturas, tintas, adhesivos y resinas que contienen sustancias peligrosas.'
            },
            {
              code: '20 01 28',
              text: 'Pinturas, tintas, adhesivos y resinas distintos de los especificados en el código 20 01 27.'
            },
            {
              code: '20 01 29*',
              text: 'Detergentes que contienen sustancias peligrosas.'
            },
            {
              code: '20 01 30',
              text: 'Detergentes distintos de los especificados en el código 20 01 29.'
            },
            {
              code: '20 01 31*',
              text: 'Medicamentos citotóxicos y citostáticos.'
            },
            {
              code: '20 01 32',
              text: 'Medicamentos distintos de los especificados en el código 20 01 31.'
            },
            {
              code: '20 01 33*',
              text: 'Baterías y acumuladores especificados en los códigos 16 06 01, 16 06 02 ó 16 06 03 y baterías y acumuladores sin clasificar que contienen esas baterías.'
            },
            {
              code: '20 01 34',
              text: 'Baterías y acumuladores distintos de los especificados en el código 20 01 33.'
            },
            {
              code: '20 01 35*',
              text: 'Equipos eléctricos y electrónicos desechados, distintos de los especificados en los códigos 21 01 21 y 20 01 23, que contienen componentes peligrosos.'
            },
            {
              code: '20 01 36',
              text: 'Equipos eléctricos y electrónicos desechados distintos de los especificados en los códigos 21 01 21, 20 01 23 y 20 01 35.'
            },
            {
              code: '20 01 37*',
              text: 'Madera que contiene sustancias peligrosas.'
            },
            {
              code: '20 01 38',
              text: 'Madera distinta de la especificada en el código 20 01 37.'
            },
            { code: '20 01 39', text: 'Plásticos.' },
            { code: '20 01 40', text: 'Metales.' },
            {
              code: '20 01 41',
              text: 'Residuos del deshollinado de chimeneas.'
            },
            {
              code: '20 01 99',
              text: 'Otras fracciones no especificadas en otra categoría.'
            }
          ]
        },

        '20 02': {
          title:
            'Residuos de parques y jardines (incluidos los residuos de cementerios).',
          items: [
            { code: '20 02 01', text: 'Residuos biodegradables.' },
            { code: '20 02 02', text: 'Tierra y piedras.' },
            { code: '20 02 03', text: 'Otros residuos no biodegradables.' }
          ]
        },

        '20 03': {
          title: 'Otros residuos municipales.',
          items: [
            { code: '20 03 01', text: 'Mezclas de residuos municipales.' },
            { code: '20 03 02', text: 'Residuos de mercados.' },
            { code: '20 03 03', text: 'Residuos de la limpieza viaria.' },
            { code: '20 03 04', text: 'Lodos de fosas sépticas.' },
            {
              code: '20 03 06',
              text: 'Residuos de la limpieza de alcantarillas.'
            },
            { code: '20 03 07', text: 'Residuos voluminosos.' },
            {
              code: '20 03 99',
              text: 'Residuos municipales no especificados en otra categoría.'
            }
          ]
        }
      }
    }
  };
  // 1. Definimos explícitamente el orden de las secciones
  const ordenSecciones = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20'
  ];

  return (
    <section className="bg-gradient-to-b from-[#EFF5F4] to-white py-10 m-0 w-full">
      <div className="px-4 md:container md:mx-auto">
        <div className="grid grid-cols-12 gap-4 items-center">
          <div className="col-span-12 md:col-span-12 md:pr-10">
            <section className="bg-gradient-to-b from-[#EFF5F4] to-white py-10 m-0 w-full">
              <div className="px-4 md:container md:mx-auto">
                <div className="grid grid-cols-12 gap-4 items-center">
                  <div className="col-span-12 md:col-span-12 md:pr-10">
                    {/* Título oficial centrado */}
                    <h2 className="text-4xl font-bold text-center mb-2">
                      LER – Listado Europeo de Residuos (oficial)
                    </h2>
                    <h3 className="text-2xl font-bold text-center mb-4 text-[#3e4a4f]">
                      Decisión 2014/955/UE
                    </h3>
                    {ordenSecciones.map(seccion => {
                      const data = residuos[seccion];
                      if (!data) return null;

                      return (
                        <Accordion
                          key={seccion}
                          isExpandido={isExpandido === seccion}
                          onChange={() => setExpandido(seccion)}
                        >
                          <AccordionSummary className="p-4 w-full">
                            <div className="flex flex-col items-start space-y-1 w-full">
                              <span className="text-xs italic">Categoría</span>
                              <div className="flex items-center w-full text-xs lg:text-sm text-[#225b2a] font-medium">
                                <span className="font-semibold mr-2">
                                  {seccion}
                                </span>
                                <span className="flex-grow">{data.title}</span>
                              </div>
                            </div>
                          </AccordionSummary>

                          <AccordionDetails className="p-0 bg-white m-0 border-t">
                            {Object.entries(data.subsections).map(
                              ([subcode, subdata], idx) => (
                                <div key={subcode} className="w-full">
                                  {idx > 0 && (
                                    <hr className="border-gray-200 mx-8" />
                                  )}
                                  <div className="flex flex-col items-start space-y-1 w-full mb-4 pl-8">
                                    <span className="text-xs italic mt-4 block">
                                      Capítulo
                                    </span>
                                    <h3 className="text-sm lg:text-base font-bold text-[#3e4a4f]  mt-2">
                                      <span className="font-semibold mr-2">
                                        {subcode}
                                      </span>
                                      {subdata.title}
                                    </h3>
                                  </div>
                                  {subdata.items.length > 0 && (
                                    <div className="flex flex-col items-start space-y-1 pl-12 mb-4 w-full">
                                      <span className="text-xs italic">
                                        Sub capítulos
                                      </span>
                                      {subdata.items.map(item => (
                                        <p
                                          key={item.code}
                                          className="text-sm text-[#3e4a4f]"
                                        >
                                          <span className="mr-2">
                                            {item.code}
                                          </span>
                                          {item.text}
                                        </p>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              )
                            )}
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CodigosLer;
